(() => {
  const siteAButton = '.site-a-modal-button';
  const siteBButton = '.site-b-modal-button';
  const siteCButton = '.site-c-modal-button';
  const lodgeAButton = '.lodge-a-modal-button';
  const lodgeBButton = '.lodge-b-modal-button';
  const campingAreaImage = '.js-camping-area-img';

  const init = () => {
    $('body')
      .on('click', siteAButton, showSiteAModal)
      .on('click', siteBButton, showSiteBModal)
      .on('click', siteCButton, showSiteCModal)
      .on('click', lodgeAButton, showLodgeAModal)
      .on('click', lodgeBButton, showLodgeBModal)
      .on('click', campingAreaImage, showSelectedCampingAreaImage);
  }

  const showSelectedCampingAreaImage = e => {
    e.preventDefault();
    const $img = $(e.currentTarget);
    $('.js-slide-target').attr('src', $img.attr('src'));
  }

  const showSiteAModal = e => {
    e.preventDefault();
    const campingAreas = $('#data-camping-area').data('camping-area');
    const campingAreaImages = $('#data-camping-area-image').data('camping-area-image');

    siteA = campingAreas[3];
    var targetCampingAreaImages = campingAreaImages.filter(image => image.camping_area_id == siteA.id)
    $('.camping-area-detail-modal').empty();
    $('.camping-area-detail-modal').append(buildCampingAreaModal(siteA, targetCampingAreaImages));
  }

  const showSiteBModal = e => {
    e.preventDefault();
    const campingAreas = $('#data-camping-area').data('camping-area');
    const campingAreaImages = $('#data-camping-area-image').data('camping-area-image');

    siteB = campingAreas[2];
    var targetCampingAreaImages = campingAreaImages.filter(image => image.camping_area_id == siteB.id)

    $('.camping-area-detail-modal').empty();
    $('.camping-area-detail-modal').append(buildCampingAreaModal(siteB, targetCampingAreaImages));
  }

  const showSiteCModal = e => {
    e.preventDefault();

    const MultipleDependentCampingAreas = $('#data-multiple-dependent-camping-area').data('multiple-dependent-camping-area');
    const MultipleDependentCampingAreaImages = $('#data-multiple-dependent-camping-area-image').data('multiple-dependent-camping-area-image');

    siteC = MultipleDependentCampingAreas[0];
    var targetMultipleDependentCampingAreaImages = MultipleDependentCampingAreaImages.filter(image => image.multiple_dependent_camping_area_id == siteC.id)
    $('.camping-area-detail-modal').empty();
    $('.camping-area-detail-modal').append(buildCampingAreaModal(siteC, targetMultipleDependentCampingAreaImages));
  }

  const showLodgeAModal = e => {
    e.preventDefault();
    const campingAreas = $('#data-camping-area').data('camping-area');
    const campingAreaImages = $('#data-camping-area-image').data('camping-area-image');
    lodgeA = campingAreas[4];
    var targetCampingAreaImages = campingAreaImages.filter(image => image.camping_area_id == lodgeA.id)
    $('.camping-area-detail-modal').empty();
    $('.camping-area-detail-modal').append(buildCampingAreaModal(lodgeA, targetCampingAreaImages));
  }

  const showLodgeBModal = e => {
    e.preventDefault();
    const campingAreas = $('#data-camping-area').data('camping-area');
    const campingAreaImages = $('#data-camping-area-image').data('camping-area-image');
    lodgeB = campingAreas[5];
    var targetCampingAreaImages = campingAreaImages.filter(image => image.camping_area_id == lodgeB.id)
    $('.camping-area-detail-modal').empty();
    $('.camping-area-detail-modal').append(buildCampingAreaModal(lodgeB, targetCampingAreaImages));
  }

  const buildCampingAreaModal = (site, images) => {
    var campingArea =
    `
      <div class="modal-body">
        <div class="price-block">
          <div class="block-left js-slide">
            <img src="${images[0].image.admin_show_thumb.url}" class="js-slide-target">
            <div class="camping-rental-float-images">
              ${showImage(images, 0)}
              ${showImage(images, 1)}
              ${showImage(images, 2)}
              ${showImage(images, 3)}
            </div>
          </div>
          <div class="block-right">
            <div class="title">${site.area_name}</div>
            <div class="description modal-description">${site.description}</div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="button btn btn-success inversion btn-block" data-dismiss="modal">閉じる</button>
      </div>
    `
    return campingArea;
  }

  const showImage = (images, key) => {
    if (images[key] != null) {
      return `<img class="camping-rental-float-image js-camping-area-img" src="${images[key].image.admin_show_thumb.url}">`;
    }
    return '';
  }

  $(init);
})();

